// constants.js - All game configuration and tetromino shapes

export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;
export const CELL_SIZE = 25;
export const DROP_SPEED = 1000; // milliseconds

// Tetromino color codes (use as keys to look up colors)
export const COLORS = {
  0: '#1a1a2e',    // Empty cell
  1: '#00ffff',    // I piece (cyan)
  2: '#ffff00',    // O piece (yellow)
  3: '#800080',    // T piece (purple)
  4: '#00ff00',    // S piece (green)
  5: '#ff0000',    // Z piece (red)
  6: '#0000ff',    // J piece (blue)
  7: '#ffa500',    // L piece (orange)
};

// Tetromino shapes - each has 4 rotation states
export const SHAPES = {
  I: {
    color: 1,
    rotations: [
      [[0,0,0,0], [1,1,1,1], [0,0,0,0], [0,0,0,0]],
      [[0,0,1,0], [0,0,1,0], [0,0,1,0], [0,0,1,0]],
      [[0,0,0,0], [1,1,1,1], [0,0,0,0], [0,0,0,0]],
      [[0,0,1,0], [0,0,1,0], [0,0,1,0], [0,0,1,0]],
    ],
  },
  O: {
    color: 2,
    rotations: [
      [[0,1,1,0], [0,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,1,0], [0,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,1,0], [0,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,1,0], [0,1,1,0], [0,0,0,0], [0,0,0,0]],
    ],
  },
  T: {
    color: 3,
    rotations: [
      [[0,1,0,0], [1,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,1,1,0], [0,1,0,0], [0,0,0,0]],
      [[0,0,0,0], [1,1,1,0], [0,1,0,0], [0,0,0,0]],
      [[0,1,0,0], [1,1,0,0], [0,1,0,0], [0,0,0,0]],
    ],
  },
  S: {
    color: 4,
    rotations: [
      [[0,1,1,0], [1,1,0,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,1,1,0], [0,0,1,0], [0,0,0,0]],
      [[0,1,1,0], [1,1,0,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,1,1,0], [0,0,1,0], [0,0,0,0]],
    ],
  },
  Z: {
    color: 5,
    rotations: [
      [[1,1,0,0], [0,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,0,1,0], [0,1,1,0], [0,1,0,0], [0,0,0,0]],
      [[1,1,0,0], [0,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,0,1,0], [0,1,1,0], [0,1,0,0], [0,0,0,0]],
    ],
  },
  J: {
    color: 6,
    rotations: [
      [[1,0,0,0], [1,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,1,0], [0,1,0,0], [0,1,0,0], [0,0,0,0]],
      [[0,0,0,0], [1,1,1,0], [0,0,1,0], [0,0,0,0]],
      [[0,1,0,0], [0,1,0,0], [1,1,0,0], [0,0,0,0]],
    ],
  },
  L: {
    color: 7,
    rotations: [
      [[0,0,1,0], [1,1,1,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,1,0,0], [0,1,1,0], [0,0,0,0]],
      [[0,0,0,0], [1,1,1,0], [1,0,0,0], [0,0,0,0]],
      [[1,1,0,0], [0,1,0,0], [0,1,0,0], [0,0,0,0]],
    ],
  },
  q: {
    color: 7,
    rotations: [
      [[0,1,0,0], [0,0,0,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,0,0,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,0,0,0], [0,0,0,0], [0,0,0,0]],
      [[0,1,0,0], [0,0,0,0], [0,0,0,0], [0,0,0,0]],
    ],
  },
};

export const PIECE_TYPES = Object.keys(SHAPES); // ['I', 'O', 'T', 'S', 'Z', 'J', 'L']
